export const colors: { [name: string]: string } = {
  white: '255, 255, 255',
  black: '0, 0, 0',
  dark: '12, 12, 13',
  grey: '169, 169, 188',
  darkGrey: '113, 119, 138',
  lightGrey: '212, 212, 212',
  blue: '101, 127, 230',
  lightBlue: '64, 153, 255',
  yellow: '250, 188, 45',
  orange: '246, 133, 27',
  green: '84, 209, 146',
  pink: '255, 51, 102',
  red: '214, 75, 71',
  purple: '110, 107, 233',
};
